export const ROW_SIZE = 43;
export const DROPDOWN_LIST_HEIGHT = 245;
